export function normalizeRecommendations({ results }) {
  const tracks = results;

  return {
    result: {
      trackIds: tracks.map(track => track.id.toString()),
    },
  };
}
